export default "__VITE_ASSET__171622c8__"